export default __webpack_public_path__ + "static/media/greenCloudComposer.e3dff68b.svg";